import {AbstractService} from 'services/AbstractService';

const PLACEMENT_TYPES_ENUM_URL = '/api/repos/placementtypes';
const PLACEMENT_STRATEGY_TYPES_ENUM_URL = '/api/repos/placementstrategytypes';
const CURRENCY_ENUM_URL = '/api/repos/currency';
const TIMEZONES_ENUM_URL = '/api/repos/timezones';
const PROFILE_GOAL_TYPE_ENUM_URL = '/api/repos/profilegoaltype';
const BALANCING_PERIODS_ENUM_NAME = '/api/repos/optimization/balancingperiods';
const PROJECT_STATUSES_URL = '/api/repos/projectstatuses';
const ACCOUNT_STATUSES_URL = '/api/repos/accountstatuses';
const ACCOUNT_TYPES_URL = '/api/repos/accounttypes';
const CUSTOM_METRIC_TYPES_URL = '/api/repos/custommetricstypes';
const ORDER_PAY_TYPES_URL = '/api/repos/orderpaytypes';
const ORDER_FORMATS_URL = '/api/repos/orderformats';
const ORDER_GENDERS_URL = '/api/repos/ordergenders';
const AD_FORMATS_URL = '/api/channels/ad/formats';

const REGIONS_LOCALE_URLS = 'api/repos/regions/locale/{0}';

export class EnumsService extends AbstractService{
  placementTypes () {
    return this.client.get(PLACEMENT_TYPES_ENUM_URL);
  }

  placementStrategyTypes () {
    return this.client.get(PLACEMENT_STRATEGY_TYPES_ENUM_URL);
  }

  currencies () {
    return this.client.get(CURRENCY_ENUM_URL);
  }

  timezones () {
    return this.client.get(TIMEZONES_ENUM_URL);
  }

  profileGoalType () {
    return this.client.get(PROFILE_GOAL_TYPE_ENUM_URL);
  }

  balancingPeriods () {
    return this.client.get(BALANCING_PERIODS_ENUM_NAME);
  }

  projectStatuses () {
    return this.client.get(PROJECT_STATUSES_URL);
  }

  accountStatuses () {
    return this.client.get(ACCOUNT_STATUSES_URL);
  }

  accountTypes () {
    return this.client.get(ACCOUNT_TYPES_URL);
  }

  customMetricTypes () {
    return this.client.get(CUSTOM_METRIC_TYPES_URL);
  }

  orderPayTypes () {
    return this.client.get(ORDER_PAY_TYPES_URL);
  }

  orderFormats () {
    return this.client.get(ORDER_FORMATS_URL);
  }

  orderGenders () {
    return this.client.get(ORDER_GENDERS_URL);
  }

  regions (userLocale) {
    return this.client.get(REGIONS_LOCALE_URLS.format(userLocale));
  }

  adFormats () {
    return this.client.get(AD_FORMATS_URL);
  }
}
